"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var urlConfigServiceEndpoints = function () {
    function urlConfigServiceEndpoints() {
        _classCallCheck(this, urlConfigServiceEndpoints);
    }

    urlConfigServiceEndpoints.get = function get(baseUrls) {
        var serviceEndpoints = {
            autoReloadGet: baseUrls.autoReload + "/get",
            autoReloadSave: baseUrls.autoReload + "/save",
            bootstrapEcommerce: baseUrls.customerServiceBase + "bootstrapEcommerce",
            bootstrapMy: baseUrls.customerServiceBase + "bootstrapMy",
            bootstrapProfile: baseUrls.customerServiceBase + "bootstrapProfile",
            bootstrapCSO: baseUrls.customerServiceBase + "bootstrapCSO",
            careersByIds: baseUrls.careerServiceBase + "byIds/",
            careersSuggestions: baseUrls.careerServiceBase + "suggestions/",
            careersByKeywordsAndLocation: baseUrls.careerServiceBase + "byKeywordsAndLocation?",
            careersByLocation: baseUrls.careerServiceBase + "byLocation?",
            careersByLatestJobPosting: baseUrls.careerServiceBase + "byLatestJobPosting?",
            changePasswordReset: baseUrls.changePassword + "reset",
            favoriteItemsGet: baseUrls.favoriteItems + "get",
            favoriteItemsSave: baseUrls.favoriteItems + "save",
            favoriteItemsDelete: baseUrls.favoriteItems + "delete",
            favoriteLocationsGet: baseUrls.favoriteLocations + "get",
            favoriteLocationsSave: baseUrls.favoriteLocations + "save",
            favoriteLocationsDelete: baseUrls.favoriteLocations + "delete",
            favoriteMealsGet: baseUrls.favoriteMeals + "get",
            favoriteMealsSave: baseUrls.favoriteMeals + "save",
            favoriteMealsDelete: baseUrls.favoriteMeals + "delete",
            mobileOrderAvailable: baseUrls.customerServiceBase + "notification/mobileOrderAvailable",
            offersAvailable: baseUrls.offers + "available",
            offersRedeem: baseUrls.offers + "redeem",
            offersAvailableCSO: baseUrls.offers + "available/CSO",
            offersEventCSO: baseUrls.offers + "event/CSO",
            orderingRecent: baseUrls.ordering + "recent",
            orderingGetTaxAndTotal: baseUrls.ordering + "getTaxAndTotal",
            orderingSubmit: baseUrls.ordering + "submit",
            orderingCheckin: baseUrls.ordering + "checkIn",
            orderingCheckinVerification: baseUrls.ordering + "checkIn/verification",
            orderingCancel: baseUrls.ordering + "cancel",
            orderingSubmitAndCheckin: baseUrls.ordering + "submitAndCheckIn",
            passcodeNew: baseUrls.passcode + "new",
            passcodeVerify: baseUrls.passcode + "verify",
            passcodeUpdate: baseUrls.passcode + "update",
            passcodeReset: baseUrls.passcode + "reset",
            passcodeRemove: baseUrls.passcode + "remove",
            paymentMethodGet: baseUrls.paymentMethod + "/get",
            paymentMethodDelete: baseUrls.paymentMethod + "/delete",
            subscribe: baseUrls.customerServiceBase + "subscribe/optIn",
            balanceCombined: baseUrls.customerServiceBase + "balance/combined",
            accountTransactions: baseUrls.customerServiceBase + "accountTransactions",
            orderingLoadMobileAccount: baseUrls.ordering + "loadMobilePaymentAccount",
            createProfile: baseUrls.customerServiceBase + "createProfile",
            getProfile: baseUrls.customerServiceBase + "getProfile",
            updateProfile: baseUrls.customerServiceBase + "updateProfile",
            changePasswordChange: baseUrls.customerServiceBase + "changePassword/change",
            resetPassword: baseUrls.customerServiceBase + "resetPassword",
            getSecurityQuestion: baseUrls.customerServiceBase + "getSecurityQuestion",
            transactionHistorySummary: baseUrls.transactionHistory + "summary",
            verificationDetails: baseUrls.customerServiceBase + "createProfile/verification/details",
            updatePostal: baseUrls.customerServiceBase + "updateProfile/postal",
            giveAwayRedemption: baseUrls.customerServiceBase + "giveAway/redemption",
            giftCardBalance: baseUrls.customerServiceBase + "balance/giftCard"
        };
        return serviceEndpoints;
    };

    return urlConfigServiceEndpoints;
}();

exports.default = urlConfigServiceEndpoints;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/config/url.config.service.endpoints.js
// module id = 605
// module chunks = 0